import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { class: "text-center mt-4" }

import { ref } from "vue";

import { Modal } from "flowbite-vue";
import AlertModal from "@/components/AlertModalFeedback.vue";




export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmOperationModal',
  setup(__props, { expose: __expose }) {


const showConfirm = ref(false);
const alertConfirmMessage = ref<null | string>(null);
const modalType = ref<"confirm" | "alert">("confirm");

let resolvePromise: (value: PromiseLike<boolean> | boolean) => void;

function openModal(message: string, alertModal: boolean) {
  alertConfirmMessage.value = message;
  alertModal ? (modalType.value = "alert") : (modalType.value = "confirm");
  showConfirm.value = true;
  return new Promise((resolve) => {
    resolvePromise = resolve;
  });

}
function handleUserInput(value: boolean) {
  if (!resolvePromise) return;
  resolvePromise(value);
  showConfirm.value = false;
}
__expose({ openModal });

const alertModal = ref<InstanceType<typeof AlertModal> | null>(null);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showConfirm.value)
      ? (_openBlock(), _createBlock(_unref(Modal), {
          key: 0,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (handleUserInput(false)))
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('editAnamnesiConfirm')), 1),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (handleUserInput(true))),
                type: "button",
                class: "text-white bg-gray-800 hover:bg-gray-900 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700"
              }, _toDisplayString(_ctx.$t("Si")), 1),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (handleUserInput(false))),
                type: "button",
                class: "text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700"
              }, _toDisplayString(_ctx.$t("No")), 1)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(AlertModal, {
      ref_key: "alertModal",
      ref: alertModal
    }, null, 512)
  ], 64))
}
}

})